import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Stats from './components/Stats';
import About from './components/About';
import LaptopSales from './components/LaptopSales';
import Spares from './components/Spares';
import BrandSlider from './components/BrandSlider';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <Stats />
      <About />
      <LaptopSales />
      <Spares />
      <BrandSlider />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
